/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Automatic/SubscriptionSecondaryTextComponent" />

import * as React from "react";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ActionCreatorManager } from "DistributedTask/Flux/ActionCreatorManager";
import { ActionsCreatorInstanceIds } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import { IdentityType } from "../../Contracts/IdentityType";
import { FormatComponent } from "VSS/Platform/Components/Format";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { EndpointsEditorActionsCreator } from "DistributedTaskUI/ServiceEndpoints/Editor/Actions/EndpointsEditorActionsCreator";

export class SubscriptionSecondaryTextComponent extends VssComponent {
    private readonly _endpointsEditorActionsCreator: EndpointsEditorActionsCreator;

    constructor(context: IVssComponentContext) {
        super(context);

        this._endpointsEditorActionsCreator = ActionCreatorManager.GetActionCreator<EndpointsEditorActionsCreator>(EndpointsEditorActionsCreator, ActionsCreatorInstanceIds.EndpointsEditorActionsCreatorInstanceId);
    }

    private handleClick = (): void => {
        this._endpointsEditorActionsCreator.setServiceEndpointIdentityType(IdentityType.AppRegistrationManual);
    }

    public render(): React.ReactNode {
        return !this.props.disableComponent ? (
            <FormatComponent className="secondary-text fontSizeS" elementType="div" format={Resources.SubscriptionSecondaryText}>
                <span onClick={this.handleClick} className="links-connections bolt-link">
                    {Resources.SubscriptionSecondaryText2}
                </span>
            </FormatComponent>
        ) : null;
    }
}
